import { ParsedUrlQuery } from 'querystring';

export const getIsMobileClient = (query: ParsedUrlQuery) => {
	const deviceType = query.device_type;
	return typeof deviceType === 'string' && ['ios', 'android'].includes(deviceType);
};
